<template>
    <div v-if="sort!==0" style="width: 100%; position: fixed; bottom: 0; left: 0">
        <v-row justify="center" class="bottom-bar" no-gutters>
            <v-col cols="12" md="8" lg="6" sm="12">
                <v-row justify="space-around">
                    <v-col cols="3" sm="4">
                        <v-row justify="center"><button class="body-1 bottom-bar-back" @click="prevStage"><span class="button-font">BACK</span></button></v-row>
                    </v-col>
                    <v-col cols="3" sm="4">
                        <v-row justify="center">
                        <button v-if="!loading" class="body-1 bottom-bar-next" @click="nextStage"><span class="button-font" style="margin:auto">SAVE & NEXT</span></button>
                        <span v-else class="body-1 bottom-bar-loading">
                            <span class="spin">&bull;</span>
                        </span>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            loading: false
        }
    },
    props: {
        sort: Number,
        stage: Object,
        questions_count: Number,
        validate: Function,
        submit: Function,
        application_id: [String, Number]
    },
    methods: {
        prevStage: function() {
            if (this.application_id === null) {
                if (this.sort === 0) {
                    return;
                }
                this.$router.push({ name: `${this.stage.key}.${(parseInt(this.sort) - 1).toString()}` });
                return;
            }

            if (this.sort == 1) {
                this.$router.push({
                    name: "stage.start",
                    params: {
                        stage_key: this.stage.key
                    }
                });
                return;
            }

            this.$router.push({
                name: "stage.question",
                params: {
                    stage_key: this.stage.key,
                    sort: (parseInt(this.sort) - 1).toString()
                }
            });
        },
        nextStage: async function() {
            console.log('Nextstage');
            console.log(this.$props);
            this.loading = true;
            if (!this.validate()) {
                this.loading = false;
                return;
            }

            if (!await this.submit()) {
                this.loading = false;
                return;
            }
            this.loading = false;

            if (this.application_id === null) {
                if (this.sort === this.questions_count) {
                    this.$router.push({ name: `home.dashboard` });
                    return;
                }

                this.$router.push({ name: `${this.stage.key}.${(parseInt(this.sort) + 1).toString()}` });
                return;
            }

            if (this.sort == this.questions_count) {
                this.$router.push({
                    name: "stage.finish",
                    params: {
                        application_id: this.application_id,
                        stage_key: this.stage.key
                    }
                });
                return;
            }

            this.$router.push({
                name: "stage.question",
                params: {
                    stage_key: this.stage.key,
                    application_id: this.application_id,
                    sort: (parseInt(this.sort) + 1).toString()
                }
            });
            return;
        }
    }
}
</script>
<style lang="scss" scoped>
.bottom-bar {
    background: white;
    box-shadow: 0px -2px 2px 0 rgba(0, 0, 0, 0.2);
}

.bottom-bar-back {
    border-radius: 3px;
    border: solid 2px #4d4d4d;
    max-width: 135px;
    width: 100%;
    height: 53px;
    color: #4d4d4d;
    padding: 0 20px 0 20px;
}


.bottom-bar-next {
    max-width: 177px;
    padding: 0 20px 0 20px;
    width: 100%;
    height: 53px;
    color: white;
    background-color: $go-orange;
    border: 1px solid $go-orange;
    border-radius: 3px;
}

.button-font
{
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    text-align: center;
}

.bottom-bar-next:hover {
    color: $go-dark-grey;
    cursor: pointer;
}


.bottom-bar-back:hover {
    color: white;
    background-color: $go-dark-grey;
}

.bottom-bar-loading {
    width: 177px;
    height: 53px;
    float: right;
    color: white;
    background-color: white;
    border: 3px solid $go-orange;
    border-radius: 3px;
    min-width: 138px;
}

.spin {
    color:$go-orange;
    display: flex;
    padding-top: 12px;
    justify-content: center;
    -webkit-animation: dotting 2s infinite;
    -o-animation: dotting 2s infinite;
    animation: dotting 2s infinite;
}

@keyframes dotting {
    0% {
        text-shadow: 0 0 0 currentColor;
    }
    33% {
        text-shadow: -20px 0 0 currentColor;
    }
    66% {
        text-shadow: -20px 0 0 black, 20px 0 0 currentColor;
    }
    100% {
        text-shadow: 0px 0 0 currentColor;
    }
}

</style>
